import { useContext } from 'react';
import { SugiIcon } from 'src/components/shared/elements/icons/SugiIcon';
import { TokyuIcon } from 'src/components/shared/elements/icons/TokyuIcon';
import { I18nContext } from 'src/stores/I18n';
import styles from './index.module.scss';

type Props = {
  categorySlug: 'drug' | 'alcohol';
};

export const VendorName: React.FC<Props> = ({ categorySlug }) => {
  const localeResources = useContext(I18nContext);
  const isCategoryDrug = categorySlug === 'drug';
  const isCategoryAlcohol = categorySlug === 'alcohol';

  return (
    <p className={styles.vendor}>
      <span>{`${localeResources.commons.vendor} : `}</span>
      {isCategoryDrug && (
        <>
          <SugiIcon />
          <span>{localeResources.vendor.sugi}</span>
        </>
      )}
      {isCategoryAlcohol && (
        <>
          <TokyuIcon />
          <span>{localeResources.vendor.tokyu}</span>
        </>
      )}
    </p>
  );
};
